'use client';
import { useChartsContext } from '../ChartsProvider/useChartsContext';

/**
 * @deprecated Use `useChartsContext` instead. We added S to the charts prefix to align with other components.
 */
export const useChartContext = useChartsContext;
